import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_STORE_OPENING_TIMES_BY_CODE } from '../../queries/get-store-opening-times.js';
import { fromStoreOpeningTimesByCodeQueryToOpeningTimes } from './adapters/fromStoreOpeningTimesQueryToOpeningTimes.js';

const useStoreOpeningTimes = ()=>{
    const [query, queryState] = useLazyQuery(GET_STORE_OPENING_TIMES_BY_CODE);
    const data = React.useMemo(()=>{
        var ref;
        return fromStoreOpeningTimesByCodeQueryToOpeningTimes((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        query,
        queryState,
        data
    ]);
};

export { useStoreOpeningTimes as default, useStoreOpeningTimes };
//# sourceMappingURL=use-store-opening-times.js.map
